import { ExcelStyle } from 'ag-grid-enterprise'
import { range } from 'lodash'
import { COLUMN_TYPE_BG_COLORS } from './excelNumberFormat'

// utils/excelStyles.ts
export const createExcelStyles = (): ExcelStyle[] => {
  const baseStyles: ExcelStyle[] = [
    { id: 'bold', font: { bold: true } },
    { id: 'italic', font: { italic: true } },
    { id: 'text', alignment: { horizontal: 'Left' } }
  ]

  const indentStyles: ExcelStyle[] = range(1, 8).map(indent => ({
    id: `indent-${indent}`,
    alignment: { indent },
    dataType: 'String'
  }))

  const decimalStyles = range(0, 7).map(decimals => {
    // Finnish number format: space separator every 3 digits (1 000, 1 000 000), comma as decimal separator
    // Using multiple groups to ensure separators work for millions and billions
    const baseStyle = '# ### ### ##0'
    const format = decimals === 0 ? baseStyle : `${baseStyle}.${'0'.repeat(decimals)}`
    return {
      id: `decimal${decimals}`,
      numberFormat: { format: `${format};-${format};` }
    }
  })

  const percentageStyles = range(0, 7).map(decimals => {
    // Finnish number format: space separator every 3 digits (1 000, 1 000 000), comma as decimal separator
    // Using multiple groups to ensure separators work for millions and billions
    const baseStyle = '# ### ### ##0%'
    const format = decimals === 0 ? baseStyle : `${baseStyle.slice(0, -1)}.${'0'.repeat(decimals)}%`
    return {
      id: `percentage${decimals}`,
      numberFormat: { format: `${format};-${format};` }
    }
  })

  // Column background styles
  // Note: Excel doesn't support alpha transparency, so colors are pre-blended with white background
  const columnStyles: ExcelStyle[] = Object.entries(COLUMN_TYPE_BG_COLORS).map(([id, color]) => ({
    id,
    interior: { color, pattern: 'Solid' }
  }))

  return [...baseStyles, ...indentStyles, ...decimalStyles, ...percentageStyles, ...columnStyles]
}
